import { Box, InputLabel, TextField, TextFieldProps } from "@mui/material";
import { ReactNode } from "react";

export function LabeledInputFull(
  props: TextFieldProps & {
    endAdornment?: ReactNode;
    customHeight?: number;
    disablePaste?: boolean;
  }
) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      width="100%"
      my={1}
    >
      <InputLabel style={{ fontSize: 13 }}>{props.label}</InputLabel>
      <TextField
        {...props}
        onPaste={(e) => {
          if (props.disablePaste) {
            e.preventDefault();
          }
          props.onPaste?.(e);
        }}
        label={null}
        fullWidth
        InputProps={{ endAdornment: props.endAdornment || null }}
        FormHelperTextProps={{
          ...(props.FormHelperTextProps || {}),
          sx: {
            ...(props.FormHelperTextProps?.sx || {}),
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
            hyphens: "auto",
          },
        }}
        sx={{
          ...(props.customHeight && {
            "& .MuiInputBase-root": { height: props.customHeight },
          }),
          "& .MuiOutlinedInput-root.Mui-disabled": {
            overflow: "hidden",
            backgroundColor: "rgba(0, 0, 0, 0.06)",
            "& fieldset": {
              border: "1px solid rgba(0,0,0,0.2)",
              borderRadius: "4px",
            },
          },
          "& .MuiInputBase-inputMultiline": {
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          },

          "& .MuiFormHelperText-root": {
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
            hyphens: "auto",
          },
        }}
      />
    </Box>
  );
}
